import { render } from "./ProductCardFavorite.vue?vue&type=template&id=2b39d588&scoped=true"
import script from "./ProductCardFavorite.vue?vue&type=script&lang=js"
export * from "./ProductCardFavorite.vue?vue&type=script&lang=js"

import "./ProductCardFavorite.vue?vue&type=style&index=0&id=2b39d588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39d588"]])

export default __exports__